export default [
  {
    name: 'CreditProcessesList',
    path: 'credit-processes',
    component: () => import('pages/credit-processes/list/CreditProcessesList.vue')
  },
  {
    name: 'CreditProcessesCreate',
    path: 'credit-processes/new',
    component: () => import('pages/credit-processes/create/CreditProcessesCreate.vue')
  },
  {
    name: 'CreditProcessesDocumentEdit',
    path: 'credit-processes/:id/document/edit',
    component: () => import('pages/credit-processes/document-edit/CreditProcessesDocumentEdit.vue')
  },
  {
    name: 'CreditProcessesBankEdit',
    path: 'credit-processes/:id/bank/edit',
    component: () => import('pages/credit-processes/bank-edit/CreditProcessesBankEdit.vue')
  },
  {
    name: 'CreditProcessesSingleLayout',
    path: 'credit-processes/:id',
    component: () => import('pages/credit-processes/single/_layouts/CreditProcessesSingleLayout'),
    redirect: { name: 'CreditProcessesSummaryList' },
    children: [
      {
        path: 'summary',
        name: 'CreditProcessesSummaryList',
        component: () => import('pages/credit-processes/single/tabs/summary-list/CreditProcessesSummaryList'),
        meta: { slug: 'summary' }
      },
      {
        path: 'documents',
        name: 'CreditProcessesDocumentsList',
        component: () => import('pages/credit-processes/single/tabs/CreditProcessesDocumentsList'),
        meta: { slug: 'documents' }
      },
      {
        path: 'simulators',
        name: 'CreditProcessesSimulatorsList',
        component: () => import('pages/credit-processes/single/tabs/simulators/CreditProcessesSimulatorsList'),
        meta: { slug: 'simulators' }
      },
      {
        path: 'history',
        name: 'CreditProcessesHistoryList',
        component: () => import('pages/credit-processes/single/tabs/CreditProcessesHistoryList'),
        meta: { slug: 'history' }
      }
    ]
  },
  {
    path: 'credit-processes/:id/simulators/:simulatorId',
    name: 'CreditProcessesSimulatorsSingle',
    component: () => import('pages/credit-processes/single/tabs/simulators/single/CreditProcessesSimulatorsSingle.vue')
  },
  {
    path: 'credit-processes/:id/simulators/:simulatorId/edit',
    name: 'CreditProcessesSimulatorsEdit',
    component: () => import('pages/credit-processes/single/tabs/simulators/CreditProcessesSimulatorsEdit.vue')
  }
]
